import axios from 'axios'
import queryString from 'query-string'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import {
  TransactionActivitiesParams,
  TransactionActivitiesResponse,
} from 'src/queries/transactionActivities/transactionActivities.models'

export const getTransactionActivities = async (
  transactionId: string | undefined,
  params?: TransactionActivitiesParams,
): Promise<TransactionActivitiesResponse> => {
  if (!transactionId) {
    throw new Error('Transaction activity transactionId is required')
  }

  const qs = queryString.stringify(params ?? {})

  return getResponseData(
    axios.get<TransactionActivitiesResponse>(
      `/transactions/${transactionId}/activities${qs ? `?${qs}` : ''}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
